<template>
  <li>
    <p class="faq-tit" v-on:click="toggle" v-bind:class="{on: isActive}">{{ title }}</p>
    <ul class="faq-exp" v-bind:class="{fadeIn: isActive, fadeOut: !isActive}">
      <template v-if="contents.length === 1">
        <template v-if="contents[0].thumbnailUrl">
          <div class="img-wrap">
            <ImageModal :image-url="assetThumbnail(contents[0].thumbnailUrl)"/>
          </div>
          <div class="tx-wrap">{{ contents[0].description }}</div>
        </template>
        <template v-else>
          <div class="tx-wrap wide">{{ contents[0].description }}</div>
        </template>
      </template>
      <template v-else-if="contents.length > 1">
        <li v-for="content in contents" v-bind:key="content">
          <template v-if="content.thumbnailUrl">
            <div class="img-wrap">
              <ImageModal :image-url="assetThumbnail(content.thumbnailUrl)"/>
            </div>
            <div v-html="content.description" class="tx-wrap"></div>
          </template>
          <template v-else>
            <div v-html="content.description" class="tx-wrap wide"></div>
          </template>
        </li>
      </template>
    </ul>
  </li>
</template>

<script>
import ImageModal from "./ImageModal";

export default {
  name: "ExpendableCard",
  components: {ImageModal},
  props: ["contents", "title", "isActiveDefault"],
  data() {
    return {
      isActive: !!this.isActiveDefault
    }
  },
  methods: {
    toggle: function () {
      this.isActive = !this.isActive
    },
    assetThumbnail: function (thumbnailUrl) {
      return require('../../assets' + thumbnailUrl)
    }
  }
}
</script>

<style scoped>
#apply .faq-list > li {
  display: table;
  width: fit-content;
  margin: 16px auto 0;
}

#apply .faq-list > li .faq-tit {
  height: 39px;
  font-size: 14px;
  line-height: 39px;
  padding: 0 23px 0 16px;
  box-sizing: border-box;
}

.faq-list > li .faq-tit {
  width: 100%;
  height: 60px;
  font-size: 18px;
  font-weight: bold;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
}

.faq-list > li .faq-tit::after {
  content: '';
  display: inline-block;
  width: 17px;
  height: 9px;
  background: url(~@/assets/images/ico/ico-arrow.png) no-repeat center;
  background-size: contain;
  margin-left: 14px;
  transform: all .2s;
}

.faq-list > li .faq-tit.on {
  color: #53d2e3;
}

.faq-list > li .faq-tit.on::after {
  background: url(~@/assets/images/ico/ico-arrow-on.png) no-repeat center;
  background-size: contain;
  margin-bottom: 2px;
}

.faq-exp {
  max-width: 800px;
}

.faq-exp.fadeIn {
  transition: all 0.8s;
  display: block;
  overflow: auto;
}

.faq-exp.fadeOut {
  transition: all 0.8s;
  height: 0;
  padding: 0;
  line-height: 0;
  overflow: hidden;
  display: block;
}

</style>
